module.exports = __webpack_public_path__ + "img/socialmedia_banner.3e1da1c8.png";